<template>
    <div id="updatePanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="update_panel">
                <div class="panel_title">温馨提示</div>
                <div class="panel_content">
                    <div class="content_text">此功能仅限会员体验</div>
                    <div class="context_desc">请升级会员后体验</div>
                    <button class="update_btn" @click="update">升级会员</button>
                </div>
                <div class="close_btn" @click="popClose"></div>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        props:["from"],
        data() {
            return {
                
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
            },
            update(){
                this.popClose();
                this.$emit("update",this.from)
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .update_panel{
        width: 400px;
        position: relative;
        text-align: center;
        .panel_title{
            height: 60px;
            line-height: 60px;
            font-size: 30px;
            color: #b7fa00;
            background-color: #303133;
            border-top-left-radius: 26px;
            border-top-right-radius: 26px;
        }
        .panel_content{
            padding: 63px 50px 55px;
            background-color: #fff;
            border-bottom-left-radius: 26px;
            border-bottom-right-radius: 26px;
            .content_text{
                font-size: 28px;
                font-weight: bold;
                line-height: 40px;
                color: #303133;
            }
            .context_desc{
                font-size: 26px;
                color: #999;
                line-height: 64px;
            }
            .update_btn{
                display: block;
                width: 100%;
                height: 60px;
                color: #fff;
                margin-top: 55px;
                font-size: 26px;
                border-radius: 40px;
                background-color: #303133;
            }
        }
        .close_btn{
            position: absolute;
            bottom: -70px;
            left: 50%;
            margin-left: -35px;
            width: 48px;
            height: 48px;
            background-image: url("./img/update_close.png");
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 35px;
            background-color: rgba(153,153,153,0.6);
            cursor: pointer;
        }
    }
</style>